import { CHAT_DISABLE_ACTION, CHAT_ENABLE_ACTION } from "../reducers/ChatReducer";

export function chatAction(status) {
	if (status === true) {
		return {
			type: CHAT_ENABLE_ACTION,
			payload: status,
		};
	}

	return {
		type: CHAT_DISABLE_ACTION,
		payload: status,
	};
}
